import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import Root from './src/app/root/Root';
import { QueryClient, QueryClientProvider } from 'react-query';
import './src/common-utils/libraries/i18n/i18n';
import { SidebarProvider } from '@/common-utils/components/ui/sidebar';
import { TooltipProvider } from '@/common-utils/components/ui/tooltip';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallBack from './src/app/root/components/ErrorFallBack';
import useErrorStore from './src/app/store/error';
import posthog from 'posthog-js';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';


const posthogConfig = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2026-01-30',
  ...(process.env.NODE_ENV === 'development' && {
    cookieless_mode: 'always',
    persistence: 'localStorage'
  })
};
posthog.init(process.env.REACT_APP_POSTHOG_KEY, posthogConfig);


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <PostHogErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <HashRouter>
            <SidebarProvider>
              <TooltipProvider>
                <ErrorBoundary
                  FallbackComponent={ErrorFallBack}
                  onReset={() => window.location.replace('/')}
                  onError={(error, info) => {
                    useErrorStore.getState().storeError(info.componentStack);
                  }}
                >
                  <Root />
                </ErrorBoundary>
              </TooltipProvider>
            </SidebarProvider>
          </HashRouter>
        </QueryClientProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);
